import { useState, useCallback } from 'react';

const useShowPopup = () => {
	const [showPopup, setShowPopup] = useState(false);

	const doShowPopup = useCallback(
		e => {
			if (e) e.preventDefault();
			setShowPopup(true);
		},
		[setShowPopup]
	);
	const doClosePopup = useCallback(() => setShowPopup(false), [setShowPopup]);

	return [showPopup, doShowPopup, doClosePopup];
};

export default useShowPopup;
